import type { VipFragment } from '@graphql/fragments/vip.graphql.generated';

type VipPresentationSettings = {
  sortOrder?: ReadonlyArray<string>;
  excludedIDs?: ReadonlyArray<string>;
};

/**
 * Apply optional sort order and filtering to the provided list of VIPs.
 */
export const applyVipPresentationSettings = (list: ReadonlyArray<VipFragment>, settings: VipPresentationSettings | undefined, skipFilter?: boolean) => {
  if (!settings) return [...list];

  const { excludedIDs = [], sortOrder = [] } = settings;
  const filteredList = skipFilter ? [...list] : [...list.filter(item => !excludedIDs.includes(item.id))];

  if (sortOrder.length === 0) return filteredList;

  // Map items to sort keys
  const sortOrderMap = sortOrder.reduce(
    (acc, id, index) => {
      acc[id] = index;
      return acc;
    },
    {} as Record<string, number>,
  );

  return filteredList.sort((a, b) => {
    const aIndex = sortOrderMap[a.id] ?? Number.MAX_SAFE_INTEGER;
    const bIndex = sortOrderMap[b.id] ?? Number.MAX_SAFE_INTEGER;
    return aIndex - bIndex;
  });
};
